import React from 'react';
import T from 'prop-types';
import {
  Heading,
  Image,
  Masthead,
  Paragraph,
  ProductBasket,
  Page,
  LogoHsbcGlobal,
} from '@piggybank/core';
import productBasket from 'assetsAlias/basket.png';
import translations from 'contentAlias';
export const AppParentComponent = (props) => {
  return (
    <Page
      headerSlot={<Masthead marginBottom={4} logoSlot={<LogoHsbcGlobal />} />}
    >
      <ProductBasket
        imageSlot={
          <Image
            src={productBasket}
            intrinsicSize="200x126"
            alt={translations.productBasket.displayName}
            marginBottom={0}
          />
        }
        marginBottom={4}
      >
        <Paragraph marginBottom={0}>
          {translations.productBasket.heading}
        </Paragraph>
        <Heading level={3} marginBottom={0}>
          {translations.productBasket.displayName}
        </Heading>
      </ProductBasket>
      {props.children}
    </Page>
  );
};

AppParentComponent.propTypes = {
  children: T.object,
};
